<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <i class="fa fa-address-book"
                    *ngIf="displayType === 'Manage SPContacts' || displayType === 'Messaging Details'"></i>
                <span class="ml-2">{{
                    displayType === 'Manage SPContacts'?'Manage Contacts':
                    displayType==='manage_product'?'Preview Image':
                    displayType==='Messaging Details'?'Messaging Details':
                    displayType==='showtext'?'Show Text':'Target'}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="managespForm" *ngIf="displayType === 'Manage SPContacts'">
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Name</mat-label>
                            <input matInput appInputtext maxlength="25" formControlName="name" placeholder="Enter Name"
                                required class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4" style="display: flex;">
                        <div class="css27">
                            <mat-form-field appearance="fill" hideRequiredMarker style="width: 60px !important;">
                                <mat-label>+27</mat-label>
                                <input readonly class="form-control" matInput type="text" id="mobileNumberLabel"
                                    tabindex="-1" placeholder="+27" autocomplete="off" class="col-12">
                            </mat-form-field>
                        </div>
                        <div class="css272" style="width: 100%;">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Contact</mat-label>
                                <input class="form-control" matInput type="text" id="mobileNumber"
                                    (input)="onInputChangeNumber($event,'mobileNumber');onInput($event,'/^[0-9]*$/')"
                                    placeholder="Enter Contact" formControlName="mobileNumber" autocomplete="off"
                                    class="col-12">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Email</mat-label>
                            <input matInput maxlength="50" type="text" id="email" placeholder="Enter Email"
                                formControlName="email" autocomplete="off"
                                pattern="^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,15})$"
                                class="col-12">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-xl-12 text-center">
                        <button class="btn btn-secondary mr-3" (click)="Submit()">
                            Save
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
            <form [formGroup]="targetForm" *ngIf="displayType === 'Target'">
                <div class="row">
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Target Connection Count</mat-label>
                            <input matInput  maxlength="25" formControlName="targetCount"
                                placeholder="Enter Target Connection Count" required class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Target Effective</mat-label>
                            <input readonly matInput  [matDatepicker]="effectiveFrom"
                                formControlName="effectiveFrom" selectable="isSelectable(date,type)" id="effectiveFrom"
                                autocomplete="off" placeholder="Select Date" class="custom-input-border"
                                specialIsAlphaNumeric (click)="openStartDateDatePicker()">
                            <mat-datepicker-toggle matSuffix [for]="effectiveFrom" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #effectiveFrom></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-xl-12 text-center">
                        <button class="btn btn-secondary mr-3" (click)="Submit()">
                            Save
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
            <form [formGroup]="messageForm" *ngIf="displayType === 'Messaging Details'">
                <div class="row">
                    <div class="col-sm-12 col-md-12 mt-2">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                            <mat-label>To</mat-label>
                            <textarea matInput placeholder="Enter Query" rows="2" formControlName="mobilenumber" autocomplete="off" class="col-12" readonly></textarea>
                          </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 mt-2" *ngIf="data.notificationTypeString=='Email'">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Subject</mat-label>
                            <input matInput   formControlName="subject" readonly
                               required class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                          <mat-label>Message</mat-label>
                          <textarea matInput placeholder="Enter Query" formControlName="message" autocomplete="off" class="col-12" readonly></textarea>
                        </mat-form-field>
                      </div>
                      
                </div>
                <div class="row mt-4">
                    <div class="col-xl-12 text-center">
                        <button class="btn btn-secondary mr-3" (click)="Submit()" *ngIf="displayType !== 'Messaging Details'">
                            Save
                        </button>
                        <button class="btn btn-primary" (click)="Close()">
                            {{displayType==='Messaging Details'?'Close':'Cancel'}}
                        </button>
                    </div>
                </div>
            </form>
            <div *ngIf="displayType==='showtext'">
                <div class="d-flex justify-content-center">
                <img [src]="data.image" style="text-align: center;" alt="Product Logo"
                    style="width: 50%; margin-bottom: 10px;"><br><br>
                </div>
                <p  [innerHTML]="safeHtmlContent"></p>
            </div>
            <div *ngIf="displayType === 'manage_product'" class="d-flex justify-content-center">
                <img [src]="data" style="text-align: center;" alt="Product Logo"
                    style="width: 50%; margin-bottom: 10px;"><br><br>
            </div>

        </div>
    </div>
</div>
